import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const UsersIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.5627 9.57636L12.75 9.69796L13.7032 10.3553C14.461 10.8779 14.9339 11.7171 14.9936 12.6286L15 12.825V13.1248C15 14.1111 14.2385 14.9196 13.2714 14.9944L13.1248 15H7.87519C6.88887 15 6.0804 14.2385 6.00564 13.2714L6 13.1248V12.825C6 11.9044 6.42236 11.0386 7.13885 10.472L7.29684 10.3553L8.25 9.69796C9.54299 8.80627 11.2335 8.76574 12.5627 9.57636ZM7.56266 7.57636L7.75 7.69796L8.67249 8.33269C8.35326 8.45808 8.04396 8.61758 7.75 8.81119L6.34989 9.73331C5.50723 10.2883 5 11.2297 5 12.2387V12.8112C5 12.8747 5.00271 12.9377 5.00802 12.9998L2.87519 13C1.88887 13 1.0804 12.2385 1.00564 11.2714L1 11.1248V10.825C1 9.90435 1.42236 9.03865 2.13885 8.47203L2.29684 8.35528L3.25 7.69796C4.54299 6.80627 6.23353 6.76574 7.56266 7.57636ZM10.5 3C11.8807 3 13 4.11929 13 5.5C13 6.88071 11.8807 8 10.5 8C9.11929 8 8 6.88071 8 5.5C8 4.11929 9.11929 3 10.5 3ZM5.5 1C6.88071 1 8 2.11929 8 3.5C8 4.88071 6.88071 6 5.5 6C4.11929 6 3 4.88071 3 3.5C3 2.11929 4.11929 1 5.5 1Z"
		/>
	</svg>
))
